import { Model } from './model';
import { Type } from 'class-transformer';
import { Partner } from './partner';
import { TransformStringToDayJS } from './utils';
import dayjs from 'dayjs';

/**
 * A remittance document with progress counts, as returned by
 * `GET /v1/deductions/remittances`. `completed` counts deductions in a terminal
 * state (CLOSED/ARCHIVED); `total` counts all deductions on the remittance
 * (scoped to the selected customers).
 */
export class DeductionRemittance extends Model {
  id: string;

  name: string | null;

  @TransformStringToDayJS()
  received_at: dayjs.Dayjs | null;

  completed: number;

  total: number;

  @Type(() => Partner)
  partner: Partner | null;

  /**
   * A remittance is "active" while it has at least one non-terminal deduction
   * (`completed < total`). Once every deduction is CLOSED/ARCHIVED it is
   * complete — the backend sorts these to the bottom of the list.
   */
  get isComplete(): boolean {
    return this.total > 0 && this.completed >= this.total;
  }
}
